import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SentimentAnalysisModule } from '../sentiment-analysis.module';
import type { SummaryTopIssueLine } from '../../../services/sentiment-analysis-stats/sentiment-analysis-stats.service';
import { SENTIMENT_ANALYSIS_CONFIG } from '../sentiment-analysis.config';

@Component({
  selector: 'app-sentiment-analysis-summary-home',
  standalone: true,
  imports: [CommonModule, SentimentAnalysisModule],
  templateUrl: './sentiment-analysis-summary-home.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['../sentiment-analysis-home/sentiment-analysis.layout.scss'],
})
export class SentimentAnalysisSummaryHomeComponent {
  @Input({ required: true }) config!: typeof SENTIMENT_ANALYSIS_CONFIG;
  @Input({ required: true }) themes!: Array<{ themeId: string; themeName: string }>;

  @Input({ required: true }) onlyActionable!: boolean;
  @Output() onlyActionableChange = new EventEmitter<boolean>();

  @Input({ required: true }) selectedSentiment!: string;
  @Output() selectedSentimentChange = new EventEmitter<string>();
  @Input({ required: true }) sentimentOptions!: Array<{ value: string; label: string }>;

  @Input({ required: true }) selectedThemeId!: string;
  @Output() selectedThemeIdChange = new EventEmitter<string>();

  @Input() summaryText: string | null = null;
  @Input() summaryTopIssues: SummaryTopIssueLine[] = [];
  @Input() summaryNextSteps: string[] = [];
  @Input() summaryStats: { feedbackCount: number; actionableCount: number } | null = null;
  @Input({ required: true }) generating!: boolean;
  @Input({ required: true }) loadingSummary!: boolean;

  @Output() generate = new EventEmitter<void>();
}
